import { motion } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import mockup_stork_quadminds2 from '../../assets/img-torre-2.svg';
import mockup_stork_quadminds3 from '../../assets/img-torre-3.svg';
import mockup_stork_quadminds1 from '../../assets/img-torre.svg';
import mockup_mindy1 from '../../assets/mindy_mockup.png';
import mockup_quadminds1 from '../../assets/mockup_app_bienvenida.svg';
import mockup_quadminds2 from '../../assets/mockup_entregas.svg';
import mockup_quadminds3 from '../../assets/mockup_manager_app.svg';
import { isStork, isMindy } from '../../utils';

const CarouselComponent: React.FC = () => {
    const delay = 3000;
    const MindyImages = [mockup_mindy1];
    const StorkImages = [mockup_stork_quadminds1, mockup_stork_quadminds2, mockup_stork_quadminds3];
    const FlashImages = [mockup_quadminds1, mockup_quadminds2, mockup_quadminds3];
    const images = isMindy ? MindyImages : isStork ? StorkImages : FlashImages;
    const [currentImage, setCurrentImage] = useState(0);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(
            () => setCurrentImage((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1)),
            delay,
        );
        return () => resetTimeout();
    }, [currentImage, images.length]);

    return (
        <div className="flex flex-col items-center justify-center w-full h-full">
            {/* Container for the image */}
            <div className="relative w-full max-w-[500px] h-[300px] lg:h-[400px] xl:h-[500px] overflow-hidden flex items-center justify-center">
                {/* Single image with fade effect */}
                <motion.img
                    key={currentImage}
                    src={images[currentImage]}
                    alt="carousel-item"
                    className="w-full h-auto max-h-full" // Ensure correct width/height ratio
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.8 }}
                />
            </div>

            {/* Dots for carousel navigation */}
            <div className="flex flex-row justify-center mt-4">
                {images.map((_, index) => (
                    <motion.div
                        key={index}
                        onClick={() => setCurrentImage(index)}
                        className={
                            currentImage === index
                                ? 'bg-white w-3.5 h-3.5 rounded-full mr-4'
                                : 'w-3.5 h-3.5 rounded-full border-2 border-white bg-transparent mr-4'
                        }
                        whileHover={{ scale: 1.2 }}
                    />
                ))}
            </div>
        </div>
    );
};

export default CarouselComponent;
